import { combineReducers } from 'redux';

// Front
import Layout from './layout/reducer';

// Authentication
import Login from './auth/login/reducer';
import Account from './auth/register/reducer';
import ForgetPassword from './auth/forgetpwd/reducer';
import GetUsers from './auth/get/reducer';
import StatusUser from './auth/status/reducer';
import ChangePassword from './auth/changepwd/reducer';
import UpdateUser from './auth/update/reducer';
import DeleteUser from './auth/delete/reducer';
// Workstations
import CreateWS from './workstation/create/reducer';
import GetWS from './workstation/get/reducer';
import DeleteWS from './workstation/delete/reducer';
import UpdateWS from './workstation/update/reducer';
import CancelAllTasksWorkstation from './workstation/cancelAllTasks/reducer';
import CheckWSPositions from './workstation/checkWsPositions/reducer';
import GetNullWSPositions from './workstation/getNullWsPositions/reducer';
import BlockWorkstation from './workstation/blockWorkstation/reducer';
import UnBlockWorkstation from './workstation/unblockWorkstation/reducer';
import strictWorkstations from './workstation/strictPriority/reducer';
import unstrictWorkstations from './workstation/unstrictPriority/reducer';
import LockWSPosition from './workstation/lockWSPosition/reducer';
import UnlockWSPosition from './workstation/unlockWSPosition/reducer';
import checkWorkWSPosition from './workstation/updateCheckWork/reducer';
import getWsPositions from './workstation/getWsPositions/reducer';
import updateWorkStatusWS from './workstation/updateWorkStatusWorkstation/reducer';
import addQueuePosition from './workstation/addQueues/reducer';
import addRotationPosition from './workstation/addRotation/reducer';
import updateFacesValues from './workstation/updateFacesValues/reducer';
import getWorkstationPositionsStatus from './workstation/getPositionsStatus/reducer';
// Tasks
import GetTasks from './task/get/reducer';
import CreateTask from './task/create/reducer';
import CancelTask from './task/cancel/reducer';
import UpdateTask from './task/update/reducer';
import ReturnTask from './task/return/reducer';
import getLastTask from './task/getLast/reducer';
import resendTask from './task/resend/reducer';
import queryTaskStatusStart from './task/queryTaskStatus/reducer';
import pendingToReturnTask from './task/pentingToReturn/reducer';
import pauseQueueTask from './task/pauseQueueTask/reducer';
import resumeQueueTask from './task/resumeQueueTask/reducer';
import getDashboardQueueTasks from './task/getDashboardQueue/reducer';
import getDashboardSendTasks from './task/getDashboardSend/reducer';
import getDashboardCancelledTasks from './task/getDashboardCancelled/reducer';
import getDashboardFinishTasks from './task/getDashboardFinish/reducer';
import getTaskDashboardStats from './task/getDashboardStats/reducer';
import getTaskTrend from './task/getTaskTrend/reducer';
import getCallbacks from './task/getCallbacksPending/reducer';
import sendCallbacks from './task/sendCallbacksPending/reducer';
// Racks
import GetRacks from './racks/get/reducer';
import getAllRacks from './racks/getAll/reducer';
import getCarrierTypes from './racks/getCarrierTypes/reducer';
// Parameters
import GetAllParams from './parameters/getAll/reducer';
import GetTypeParams from './parameters/getType/reducer';
import UpdateParamGroup from './parameters/updateParamGroup/reducer';
// Map
import GetAllMap from './map/get/reducer';
import getQueuePositions from './map/getQueuePositions/reducer';
import getRotatePositions from './map/getRotatePositions/reducer';
import getMapPositions from './map/getMapPositions/reducer';
import getPositionTypes from './map/getPositionTypes/reducer';

// Warnings
import GetAllWarnings from './warnings/get/reducer';

// Security params
import getPARAM from './securityparams/get/reducer';
import deletePARAM from './securityparams/delete/reducer';
import createPARAM from './securityparams/create/reducer';

//System
import GetSystemStatus from './system/get/reducer';
import getPlcStatus from './system/plcStatus/reducer';
import getPlcPopupStatus from './system/plcPopupStatus/reducer';
import setPlcPopupStatus from './system/setplcPopupStatus/reducer';

// DMX (AA-11839)
import getDmxControllers from './dmx/getControllers/reducer';
import createDmxController from './dmx/createController/reducer';
import updateDmxController from './dmx/updateController/reducer';
import toggleDmxControllerStatus from './dmx/toggleControllerStatus/reducer';
import deleteDmxController from './dmx/deleteController/reducer';
import toggleDmxUniverseStatus from './dmx/toggleUniverseStatus/reducer';
import getDmxUniversesByController from './dmx/getUniversesByController/reducer';
import createDmxUniverse from './dmx/createUniverse/reducer';
import deleteDmxUniverse from './dmx/deleteUniverse/reducer';
import getDmxOccupancy from './dmx/getOccupancy/reducer';
import getDmxDeviceById from './dmx/getDeviceById/reducer';
import createDmxDevice from './dmx/createDevice/reducer';
import updateDmxDevice from './dmx/updateDevice/reducer';
import deleteDmxDevice from './dmx/deleteDevice/reducer';
import getDmxProfiles from './dmx/getProfiles/reducer';
import getDmxProfileById from './dmx/getProfileById/reducer';
import createDmxProfile from './dmx/createProfile/reducer';
import updateDmxProfile from './dmx/updateProfile/reducer';
import deleteDmxProfile from './dmx/deleteProfile/reducer';
import setDmxProfileChannels from './dmx/setProfileChannels/reducer';
import getDmxDevicePresets from './dmx/getDevicePresets/reducer';
import getDmxDevicePresetById from './dmx/getDevicePresetById/reducer';
import createDmxDevicePreset from './dmx/createDevicePreset/reducer';
import updateDmxDevicePreset from './dmx/updateDevicePreset/reducer';
import deleteDmxDevicePreset from './dmx/deleteDevicePreset/reducer';
import activateDmxDevicePreset from './dmx/activateDevicePreset/reducer';
import getDmxCompatibleDevices from './dmx/getCompatibleDevices/reducer';
import duplicateDmxDevicePresets from './dmx/duplicateDevicePresets/reducer';
import resyncPlcSecurities from './processingTask/resyncSecurities/reducer';

// PLC Safety (P01021-135)
import getPlcSafetyZones from './plcSafety/getZones/reducer';
import getPlcSafetyCauses from './plcSafety/getCauses/reducer';
import getPlcSafetyEvents from './plcSafety/getEvents/reducer';
import getPlcSafetyEventById from './plcSafety/getEventById/reducer';
import createPlcSafetyEvent from './plcSafety/createEvent/reducer';
import updatePlcSafetyEvent from './plcSafety/updateEvent/reducer';
import deletePlcSafetyEvent from './plcSafety/deleteEvent/reducer';
import getPlcSafetyTriggers from './plcSafety/getTriggers/reducer';
import getPlcSafetyTriggerById from './plcSafety/getTriggerById/reducer';
import createPlcSafetyTrigger from './plcSafety/createTrigger/reducer';
import updatePlcSafetyTrigger from './plcSafety/updateTrigger/reducer';
import deletePlcSafetyTrigger from './plcSafety/deleteTrigger/reducer';
import getPlcSafetyZoneDependencies from './plcSafety/getZoneDependencies/reducer';
import createPlcSafetyZoneDependency from './plcSafety/createZoneDependency/reducer';
import deletePlcSafetyZoneDependency from './plcSafety/deleteZoneDependency/reducer';
import getPlcSafetyDashboardStats from './plcSafety/getDashboardStats/reducer';

// Entry Strategies
import addAreaEntryStrategy from './entrystrategies/addAreaEntryStrategy/reducer';
import createEntryStrategy from './entrystrategies/createEntryStrategy/reducer';
import deleteEntryStrategy from './entrystrategies/deleteEntryStrategy/reducer';
import getEntryStrategies from './entrystrategies/getEntryStrategies/reducer';
import getEntryStrategyById from './entrystrategies/getEntryStrategyById/reducer';
import removeAreaEntryStrategy from './entrystrategies/removeAreaEntryStrategy/reducer';
import reorderAreaEntryStrategy from './entrystrategies/reorderAreaEntryStrategy/reducer';
import toggleEntryStrategy from './entrystrategies/toggleEntryStrategy/reducer';
import updateEntryStrategy from './entrystrategies/updateEntryStrategy/reducer';
import toggleAreaEntryStrategy from './entrystrategies/toggleAreaEntryStrategy/reducer';
import getDataRetentionPolicies from './dataRetention/getPolicies/reducer';
import updateDataRetentionPolicy from './dataRetention/updatePolicy/reducer';
import getDataRetentionSettings from './dataRetention/getSettings/reducer';
import updateDataRetentionSettings from './dataRetention/updateSettings/reducer';

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  GetUsers,
  CreateWS,
  GetWS,
  DeleteWS,
  StatusUser,
  ChangePassword,
  UpdateWS,
  UpdateUser,
  DeleteUser,
  GetTasks,
  CreateTask,
  GetAllParams,
  GetTypeParams,
  UpdateParamGroup,
  GetAllMap,
  GetAllWarnings,
  CancelTask,
  UpdateTask,
  ReturnTask,
  GetSystemStatus,
  GetRacks,
  CancelAllTasksWorkstation,
  CheckWSPositions,
  GetNullWSPositions,
  BlockWorkstation,
  UnBlockWorkstation,
  getPARAM,
  deletePARAM,
  createPARAM,
  LockWSPosition,
  UnlockWSPosition,
  getLastTask,
  resendTask,
  queryTaskStatusStart,
  pendingToReturnTask,
  pauseQueueTask,
  resumeQueueTask,
  checkWorkWSPosition,
  getDashboardQueueTasks,
  getDashboardSendTasks,
  getDashboardCancelledTasks,
  getDashboardFinishTasks,
  getTaskDashboardStats,
  getTaskTrend,
  getWsPositions,
  getAllRacks,
  getCarrierTypes,
  getCallbacks,
  sendCallbacks,
  getPlcStatus,
  getPlcPopupStatus,
  setPlcPopupStatus,
  strictWorkstations,
  unstrictWorkstations,
  getDmxControllers,
  createDmxController,
  updateDmxController,
  toggleDmxControllerStatus,
  deleteDmxController,
  toggleDmxUniverseStatus,
  getDmxUniversesByController,
  createDmxUniverse,
  deleteDmxUniverse,
  getDmxOccupancy,
  getDmxDeviceById,
  createDmxDevice,
  updateDmxDevice,
  deleteDmxDevice,
  getDmxProfiles,
  getDmxProfileById,
  createDmxProfile,
  updateDmxProfile,
  deleteDmxProfile,
  setDmxProfileChannels,
  getDmxDevicePresets,
  getDmxDevicePresetById,
  createDmxDevicePreset,
  updateDmxDevicePreset,
  deleteDmxDevicePreset,
  activateDmxDevicePreset,
  getDmxCompatibleDevices,
  duplicateDmxDevicePresets,
  resyncPlcSecurities,
  getPlcSafetyZones,
  getPlcSafetyCauses,
  getPlcSafetyEvents,
  getPlcSafetyEventById,
  createPlcSafetyEvent,
  updatePlcSafetyEvent,
  deletePlcSafetyEvent,
  getPlcSafetyTriggers,
  getPlcSafetyTriggerById,
  createPlcSafetyTrigger,
  updatePlcSafetyTrigger,
  deletePlcSafetyTrigger,
  getPlcSafetyZoneDependencies,
  createPlcSafetyZoneDependency,
  deletePlcSafetyZoneDependency,
  getPlcSafetyDashboardStats,
  updateWorkStatusWS,
  getQueuePositions,
  addQueuePosition,
  getRotatePositions,
  addRotationPosition,
  getMapPositions,
  getPositionTypes,
  updateFacesValues,
  getWorkstationPositionsStatus,
  addAreaEntryStrategy,
  createEntryStrategy,
  deleteEntryStrategy,
  getEntryStrategies,
  getEntryStrategyById,
  removeAreaEntryStrategy,
  reorderAreaEntryStrategy,
  toggleEntryStrategy,
  updateEntryStrategy,
  toggleAreaEntryStrategy,
  getDataRetentionPolicies,
  updateDataRetentionPolicy,
  getDataRetentionSettings,
  updateDataRetentionSettings,
});

export default rootReducer;
